import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { ContractClassificationResponse } from '../models/ContractClassificationResponse';
import { SelectItem } from '../models/SelectItem';

const CACHE_SIZE = 1;

@Injectable({
  providedIn: 'root',
})
export class ContractClassificationService {
  apiRoot: string;
  contractClassifications: SelectItem[] = [];

  constructor(private http: HttpClient) {
    this.apiRoot = environment.cmApiRoot.url;
  }


  public getContractClassificationList(): Observable<ContractClassificationResponse> {

    return this.http.get<ContractClassificationResponse>(`${this.apiRoot}/api/ContractClassifications`);
  }


}

